<template>
  <!-- 修改密码公共组件 -->
  <div class="change-pwd-box">
    <y-dialog
      title="修改密码"
      :visible.sync="showDialog"
      class="edit-password-dialog"
      :width="dialogWidth"
      sureText="保存"
      @close="handleEditPwdCancel"
      @comfirm="handleEditPwdSave"
    >
      <el-form :model="editPasswordForm" label-width="90px" class="new-input-box">
        <el-form-item label="旧密码:" required>
          <el-input
            type="password"
            v-model="editPasswordForm.oldPassword"
            :maxlength="30"
            style="width: 320px"
            @blur="handleOldPwd"
          />
          <div class="edit-pwd-text-tip" v-if="discrepancyOldPwd">
            请填写旧密码
          </div>
        </el-form-item>
        <el-form-item label="新密码:" required>
          <el-input
            type="password"
            v-model="editPasswordForm.password"
            style="width: 320px"
            :maxlength="30"
            @blur="handleNewPwd"
          />
          <div class="edit-pwd-text">
            必须8-30位同时包含大小写字母、数字以及特殊字符
          </div>
          <div class="edit-pwd-text-tip" v-if="discrepancyNewPwd == '0'">
            请填写登录密码
          </div>
          <div class="edit-pwd-text-tip" v-if="discrepancyNewPwd == '1'">
            密码必须8-30位同时包含大小写字母、数字以及特殊字符
          </div>
        </el-form-item>
        <el-form-item label="确认密码:" required>
          <el-input
            type="password"
            v-model="editPasswordForm.confirmPassword"
            :maxlength="30"
            style="width: 320px"
            @blur="handleAgainPwd"
          />
          <div class="edit-pwd-text-tip" v-if="discrepancyAgainPwd">
            两次输入密码不一致
          </div>
        </el-form-item>
      </el-form>
    </y-dialog>
  </div>
</template>

<script>
import { changeUserPwd } from "@/api/header/cursorPointer";
export default {
  props: {
    showChangePwd: {
      type: Boolean,
      default: false,
    },
    pwdForm: {
      type: Object,
      default() {
        return {
          platformCompanyUserId: "",
          oldPassword: "",
          password: "",
          confirmPassword: "",
        };
      },
    },
    // 弹框宽度
    dialogWidth: {
      type: String,
      default: "455px",
    },
    // 遮罩层开关
    isModel: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      showDialog: false,
      editPasswordForm: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
      },
      // 修改员工密码
      discrepancyNewPwd: "", // 新密码缺少设置为0，不符合设置为1
      discrepancyOldPwd: false, // 旧密码是否为空
      discrepancyAgainPwd: false, // 两次密码是否一致
    };
  },
  mounted() {
    this.showDialog = this.showChangePwd || false;
    this.editPasswordForm.platformCompanyUserId = this.pwdForm.platformCompanyUserId
    this.editPasswordForm.oldPassword = this.pwdForm.oldPassword
    this.editPasswordForm.password = this.pwdForm.password
    this.editPasswordForm.confirmPassword = this.pwdForm.confirmPassword
    console.log("this.editPasswordForm", this.editPasswordForm);
  },
  watch: {
    showChangePwd: {
      handler(newValue) {
        if (newValue) {
          this.showDialog = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 监听旧密码
    handleOldPwd() {
      console.log("oldPassword", this.editPasswordForm.oldPassword);
      if (this.editPasswordForm.oldPassword == "") {
        this.discrepancyOldPwd = true;
        return;
      } else {
        this.discrepancyOldPwd = false;
        return;
      }
    },
    // 监听新密码
    handleNewPwd() {
      console.log("password", this.editPasswordForm.password);
      const regex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&'"()*+,\-./:;<=>?@\[\]\^_`{|}~])[A-Za-z\d!#$%&'"()*+,\-./:;<=>?@\[\]\^_`{|}~]{8,30}$/;
      if (this.editPasswordForm.password == "") {
        this.discrepancyNewPwd = "0";
        return;
      } else if (!regex.test(this.editPasswordForm.password)) {
        this.discrepancyNewPwd = "1";
        this.editPasswordForm.password = "";
        return;
      } else if (
        this.editPasswordForm.password != this.editPasswordForm.confirmPassword
      ) {
        this.discrepancyNewPwd = "";
        this.discrepancyAgainPwd = true;
      } else {
        this.discrepancyNewPwd = "";
        this.discrepancyAgainPwd = false;
        return;
      }
    },
    // 监听二次确认密码
    handleAgainPwd() {
      console.log("confirmPassword", this.editPasswordForm.confirmPassword);
      if (this.editPasswordForm.password == this.editPasswordForm.confirmPassword) {
        this.discrepancyAgainPwd = false;
        return;
      } else {
        this.discrepancyAgainPwd = true;
        return;
      }
    },
    // 修改密码取消
    handleEditPwdCancel() {
      this.editPasswordForm = {
        platformCompanyUserId: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      };
      this.discrepancyNewPwd = "";
      this.discrepancyOldPwd = false;
      this.discrepancyAgainPwd = false;
      this.$emit("close");
    },
    // 修改密码保存
    handleEditPwdSave() {
      let params = this.editPasswordForm;
      console.log("handleEditPwdSave", params);
      if(!params.oldPassword || params.oldPassword == ''){
        this.$message.warning("请填写旧密码");
        return;
      }
      if(!params.password || params.password == ''){
        this.$message.warning("新密码为空");
        return;
      }
      if(!params.confirmPassword || params.confirmPassword == ''){
        this.$message.warning("请补充确认密码");
        return;
      }
      if(this.discrepancyNewPwd != '' || this.discrepancyOldPwd || this.discrepancyAgainPwd){
        this.$message.warning("请修改不符合规则的内容");
        return;
      }
      console.log("params", params);
      changeUserPwd(params).then(res => {
        if(res.code == '200'){
          this.$message.success(res.message);
          this.$emit("saveEditSave", true);
        }else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.$message.error(err.message);
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>